/** /user_preferences/ — the current console user's preferences (console namespace).
 *
 * Self-scoped key/value store. Keys are namespaced by convention (e.g.
 * `grid_default:<grid>` → a preset id). Hand-authored wrapper (console
 * convention). DELETE carries a body, so it goes through the axios client
 * directly (the `apiDelete` helper takes no body).
 */
import { apiGet, apiPut, client } from './client';

export interface UserPreference {
  key: string;
  value: unknown;
  updated_ts: string | null;
}

export interface UserPreferencesList {
  count: number;
  results: UserPreference[];
}

interface UpsertResult {
  updated: { key: string; value: unknown }[];
  created: { key: string; value: unknown }[];
}

export function list(): Promise<UserPreferencesList> {
  return apiGet<UserPreferencesList>('/user_preferences/');
}

/** Bulk upsert `{ key: value, … }`. */
export function save(prefs: Record<string, unknown>): Promise<UpsertResult> {
  return apiPut<UpsertResult>('/user_preferences/', prefs);
}

export async function remove(keys: string[]): Promise<void> {
  await client.delete('/user_preferences/', { data: { keys } });
}
